import axios from "axios";

export default axios.create({
  baseURL: "https://api.unsplash.com",
  headers: {
    Authorization: `Client-ID D_dcn4MXyiGsnhObMAXQPmYVr8CLKT2Ct6Cf-gmKjnk`,
  },
});
